import { render, staticRenderFns } from "./SetupSummaryLicences.vue?vue&type=template&id=5d7f34da&"
import script from "./SetupSummaryLicences.vue?vue&type=script&lang=js&"
export * from "./SetupSummaryLicences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\websites\\newshop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d7f34da')) {
      api.createRecord('5d7f34da', component.options)
    } else {
      api.reload('5d7f34da', component.options)
    }
    module.hot.accept("./SetupSummaryLicences.vue?vue&type=template&id=5d7f34da&", function () {
      api.rerender('5d7f34da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/LicenceSetup/SetupSummaryLicences.vue"
export default component.exports